import React from 'react';
import { Box, Typography, Card, Tabs, Tab, Chip } from '@mui/material';
import {
  RateReview as RateReviewIcon,
  Article as ArticleIcon,
  AccountCircle as AccountIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import FeedLayout from '../../components/feed/FeedLayout';

const pageConfigs = {
  posting: {
    title: 'Posting',
    subtitle: 'Create and manage posts across your GBP locations',
    icon: <ArticleIcon sx={{ fontSize: 80 }} />,
    tabs: ['Create Post', 'Scheduled', 'Published', 'Drafts'],
    features: [
      'Create posts for single or multiple locations',
      'Schedule posts in advance',
      'Track post performance',
      'Manage post templates',
    ],
  },
  reviews: {
    title: 'Review Management',
    subtitle: 'Monitor and respond to customer reviews',
    icon: <RateReviewIcon sx={{ fontSize: 80 }} />,
    tabs: ['All Reviews', 'Needs Response', 'Responded', 'Flagged'],
    features: [
      'View all reviews in one place',
      'Respond to reviews quickly',
      'Flag reviews for follow-up',
      'Track response metrics',
    ],
  },
  account: {
    title: 'Account',
    subtitle: 'Manage your account settings and preferences',
    icon: <AccountIcon sx={{ fontSize: 80 }} />,
    tabs: ['Profile', 'Settings', 'Notifications', 'Team'],
    features: [
      'Update profile information',
      'Manage notification preferences',
      'Invite team members',
      'Configure access permissions',
    ],
  },
};

const FeedComingSoon = ({ pageType = 'posting' }) => {
  const config = pageConfigs[pageType] || pageConfigs.posting;

  return (
    <FeedLayout title={config.title} subtitle={config.subtitle}>
      {/* Placeholder Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
        <Tabs
          value={0}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
            },
            '& .Mui-selected': {
              color: '#3b5998',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#3b5998',
            },
          }}
        >
          {config.tabs.map((tab, idx) => (
            <Tab key={idx} label={tab} disabled={idx !== 0} />
          ))}
        </Tabs>
      </Box>

      {/* Coming Soon Card */}
      <Card
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          p: 6,
          textAlign: 'center',
          maxWidth: 600,
          mx: 'auto',
        }}
      >
        <Box sx={{ color: 'rgba(59, 89, 152, 0.3)', mb: 3 }}>{config.icon}</Box>

        <Chip
          icon={<ScheduleIcon />}
          label="Coming Soon"
          sx={{
            bgcolor: 'rgba(245, 158, 11, 0.1)',
            color: '#f59e0b',
            fontSize: '1rem',
            py: 2.5,
            px: 1,
            mb: 3,
          }}
        />

        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1a2b4a', mb: 2 }}>
          {config.title}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400, mx: 'auto' }}>
          This feature is currently under development. We're working hard to bring you powerful
          tools for managing your GBP portfolio.
        </Typography>

        {/* Feature List */}
        <Box sx={{ textAlign: 'left', maxWidth: 350, mx: 'auto' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1a2b4a', mb: 2 }}>
            What's Coming:
          </Typography>
          {config.features.map((feature, idx) => (
            <Box
              key={idx}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 1.5,
              }}
            >
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  bgcolor: '#3b5998',
                }}
              />
              <Typography variant="body2" color="text.secondary">
                {feature}
              </Typography>
            </Box>
          ))}
        </Box>
      </Card>
    </FeedLayout>
  );
};

export default FeedComingSoon;
